import React, { useEffect, useState } from "react";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";
import { takeContextNote } from "../../utils/readingContext";

// Switching workspace can move the database with it (utils/readingContext.js).
// That must never be silent - the reader would find a different library open
// and not know why - but it is not an error either: one quiet line, on the
// other side of the reload the switch causes, and then it is gone.
export default function ContextNote() {
  const [note, setNote] = useState("");

  useEffect(() => {
    setNote(takeContextNote());
  }, []);

  if (!note) return null;
  return (
    <Snackbar
      open
      autoHideDuration={8000}
      onClose={() => setNote("")}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert severity="info" variant="filled" onClose={() => setNote("")} sx={{ borderRadius: 2 }}>
        {note}
      </Alert>
    </Snackbar>
  );
}
